import { User, Merchant } from './index';

export interface Customer {
  _id?: string;
  nanoid?: string;
  user?: string | User;
  merchant?: string | Merchant;
  name?: string;
  stamps?: number;
  points?: number;
  rewards?: number;
  pushNotifications?: number;
  redemptions?: number;
  createdAt?: Date;
  email?: string;
  dob?: string;
  checked?: boolean;
  notes?: string;
}
